import React from 'react';
import { connect } from 'react-redux';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Input } from 'reactstrap';

import Product from './Product';

import {
    addToPurchase,
    updatePurchase,
    changeView
} from '../../../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';

import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../../api-config';
import { auth } from '../../../../../../../services';

class ProductOrder extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            view: "ProductOrder",
            title: "Added Product Order",
            id: 0,
            Name: "",
            SuggestedCost: 0,
            productLineItems: [],
            filterResults: [],
            value: '',
            data: [],
            Address1: this.props.purchaseAndRenewals.userInfo.address1 || "",
            Address2: this.props.purchaseAndRenewals.userInfo.address2 || "",
            City: this.props.purchaseAndRenewals.userInfo.city || "",
            Zip: this.props.purchaseAndRenewals.userInfo.zip || "",
            StateId: this.props.purchaseAndRenewals.userInfo.state.id,
            stateObj: this.props.purchaseAndRenewals.userInfo.state || "",
            touched: {
                Name: false,
                City: false,
                Address1: false,
                Zip: false
            },
        }

    }

    componentDidMount() {
        this.props.fetchStates();
        if (this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }
    }

    componentDidMount() {
        const options = { method: 'POST', headers: auth.authHeader() };
        axios.get(`${ROOT_API_URL}/Product/GetAllProducts`, options, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    data: response.data,
                });
            }).catch((response) => {
                console.log(response);
            })

        if (this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.purchaseAndRenewals.editingPurchase !== this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }
    }

    total = (productList) => {
        var totalAmount = productList.reduce(function (accumulator, product) {
            return Number(accumulator + Number(product.SuggestedCost));
        }, 0);

        return totalAmount;
    }

    handleChange = ({ target }) => {
        this.setState({ [target.name]: target.value });
    };
    

    handleState = (event) => {
        const value = event.target.value;
        if (value !== null) {
            this.setState({
                stateObj: value,
                StateId: value.id
            });
        }
    };


    setAllTouchedTrue() {
        this.setState({
            touched: {
                Name: true,
                City: true,
                Address1: true,
                Zip: true
            }
        })
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    isModelValid() {
        return this.state.Name !== "" &&
            this.state.Address1 !== "" &&
            this.state.City !== "" &&
            this.state.Zip !== "";
    }


    handleSearchChange = (event) => {
        this.setState({
            value: event.target.value
        })
        if (event.target.value !== "") {
            const updatedList = this.state.data.filter(item => {
                return (
                    item.title.toLowerCase().search(event.target.value.toLowerCase()) !== -1
                );
            });
            this.setState({ filterResults: updatedList });
        } else {
            this.setState({ filterResults: [] });
        }
    };

    addToProductList = (product) => {
        this.setState({
            value: "",
            filterResults: []
        })

        var found = false;

        for (var i = 0; i < this.state.productLineItems.length; i++) {
            if (this.state.productLineItems[i].ProductId === product.ProductId && this.state.productLineItems[i].ColorId === product.ColorId && this.state.productLineItems[i].SizeId === product.SizeId) {
                var stateCopy = Object.assign({}, this.state);
                stateCopy.productLineItems[i].Quantity += product.Quantity;
                stateCopy.value = "";
                stateCopy.filterResults = [];
                stateCopy.productLineItems[i].SuggestedCost = Number(Number(stateCopy.productLineItems[i].Quantity) * Number(product.SuggestedCost));
                stateCopy.SuggestedCost = Number(this.total(stateCopy.productLineItems));
                this.setState(stateCopy);
                found = true;
                break;
            } 
        }
        
        if (!found) {
            this.setState({
                productLineItems: [...this.state.productLineItems, product],
                SuggestedCost: Number(this.total([...this.state.productLineItems, product]))
            });

        }
    }

    removeItemFromProductList = (index) => {
        console.log(this.state.productLineItems.splice(index, 1));
        this.setState({
            productLineItems: this.state.productLineItems.splice(index, 1)
        })
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.isModelValid()) {
            if (this.props.purchaseAndRenewals.editingPurchase.Name) {
                this.props.updatePurchase(this.state);
            } else {
                this.props.addToPurchase(this.state);
            }
            this.props.changeView({ view: "AddItems" })

        } else {
            this.setAllTouchedTrue();
        }
    };

    render() {
        return (
            <div className="productOrder" key={this.props.key}>
                <form onSubmit={this.handleSubmit} className="orderProductForm">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="callout">Name <span className="highlight">Of Order</span></h2>
                            <Input
                                id="Name"
                                type="text"
                                value={this.state.Name}
                                onChange={this.handleChange}
                                name="Name"
                                invalid={this.state.touched.Name && this.state.Name === '' ? true : false}
                                onBlur={this.handleBlur('Name')}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <h2 className="callout shippingTitle">Enter <span className="highlight">Shipping Address</span></h2>
                    </div>
                    <div className="mailingAddressContainer row">
                        <div className="address1-wrapper form-group col-md-6">
                            <label htmlFor="Address1">Address 1</label>
                            <Input
                                id="Address1"
                                type="text"
                                value={this.state.Address1}
                                onChange={this.handleChange}
                                name="Address1"
                                invalid={this.state.touched.Address1 && this.state.Address1 === '' ? true : false}
                                onBlur={this.handleBlur('Address1')}
                            />
                        </div>
                        <div className="address2-wrapper form-group col-md-6">
                            <label htmlFor="Address2">Address 2</label>
                            <Input
                                id="Address2"
                                type="text"
                                value={this.state.Address2}
                                onChange={this.handleChange}
                                name="Address2"
                            />
                        </div>
                    </div>
                    <div className="cityStateZip row">
                        <div className="city-wrapper form-group col-md-4">
                            <label htmlFor="City">City</label>
                            <Input
                                id="City"
                                type="text"
                                value={this.state.City}
                                onChange={this.handleChange}
                                name="City"
                                invalid={this.state.touched.City && this.state.City === '' ? true : false}
                                onBlur={this.handleBlur('City')}
                            />
                        </div>
                        <div className="state-wrapper form-group col-md-4">
                            <label htmlFor="State">State</label>
                            <DropDownList data={this.props.common.states}
                                id="State"
                                name="state"
                                textField="name"
                                dataItemKey="id"
                                onChange={this.handleState}
                                value={this.state.stateObj}
                            />
                        </div>
                        <div className="zip-wrapper form-group col-md-4">
                            <label htmlFor="Zip">Zip</label>
                            <Input
                                id="MailingZip"
                                value={this.state.Zip}
                                onChange={this.handleChange}
                                name="Zip"
                                pattern="(\d{5}([\-]\d{4})?)"
                                type="text"
                                placeholder="12345"
                                title="Zip Code (Format: 12345 or 12345-6789)"
                                invalid={this.state.touched.Zip && this.state.Zip === '' ? true : false}
                                onBlur={this.handleBlur('Zip')}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="callout">Search <span className="highlight">For Product</span></h2>
                            <input type="text" value={this.state.value} onChange={this.handleSearchChange} />
                        </div>
                    </div>
                    <div className="filteredResults">
                        {this.state.filterResults.length !== 0 ?
                            <div className="results">
                                {
                                    this.state.filterResults.map((el, index) => (
                                        <Product key={index} product={el} addToProductList={this.addToProductList} />
                                    ))
                                }
                            </div>
                        : ""}
                    </div>
                    <div>
                        {this.state.productLineItems.length !== 0 ?
                            <div className="cartProducts">
                                <div className="row cartProducts-header">
                                    <div className="col-md-2 productRow-content"><p className="productTitle">PRODUCT IMAGE</p></div>
                                    <div className="col-md-2 productRow-content"><p className="productTitle">NAME</p></div>
                                    <div className="col-md-2 productRow-content"><p className="productTitle">COLOR</p></div>
                                    <div className="col-md-1 productRow-content"><p className="productTitle">SIZE</p></div>
                                    <div className="col-md-2 productRow-content"><p className="productTitle">QUANTITY</p></div>
                                    <div className="col-md-1 productRow-content"><p className="productTitle">PRICE</p></div>
                                </div>
                                <div className="row">
                                    <div className="col-md-10"><hr className="separator"/></div>
                                    <div className="col-md-2"></div>
                                </div>
                                {this.state.productLineItems ? this.state.productLineItems.map((product, index) => {
                                    return (
                                        <div className="row productRow" key={index}>
                                            <div className="col-md-2 productRow-content">
                                                <div className="product-image">{

                                                    product.ImageModel.base64? 
                                                    <img style={{ display: "block", margin: "0 auto", maxHeight: "100%", maxWidth: "89px" }}
                                                     src={product.ImageModel.base64} alt={product.ProductName} />
                                                     :  <img src="/images/TSCRABackgroundLOGO.png" className="defaultImgHeight" alt="..." />
                                                }
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-2 productRow-content">
                                                <div className="productImageDetails">
                                                    <p className="productName">{product.ProductName}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-2 productRow-content productRow-content-text">
                                                {product.Color ?
                                                    <div>
                                                        <span className="productColor-header-text">Color</span>
                                                        <p className="productInfo">{product.Color}</p>
                                                    </div>
                                                    : <p className="productInfo">None</p>
                                                }
                                            </div>
                                            <div className="col-md-1 productRow-content productRow-content-text">
                                                {product.Size ?
                                                    <div>
                                                        <span className="productColor-header-text">Size</span>
                                                        <p className="productInfo">{product.Size}</p>
                                                    </div>
                                                    : <p className="productInfo">None</p>
                                                }
                                            </div>
                                            <div className="col-md-2 productRow-content productRow-content-text">
                                                <p className="productInfo">{product.Quantity}</p>
                                            </div>
                                            <div className="col-md-1 productRow-content productRow-content-text">
                                                <p className="productInfo">${product.SuggestedCost}</p>
                                            </div>
                                            <div className="col-md-2 productRow-content productRow-content-text">
                                                <button className="admin-k-button" onClick={(event) => {
                                                    event.preventDefault();
                                                    this.removeItemFromProductList(index);
                                                }}>
                                                    <i className="fas fa-times"></i>
                                                    <span>Remove</span>
                                                </button>
                                            </div>
                                        </div>
                                    )
                                }) : ""}
                            </div>
                        : ""}
                    </div>                               
                    <div className="footer">
                        <div className="form-group">
                            <button type="submit" className="admin-k-button">
                                <i className="fas fa-save"></i>
                                <span>SAVE</span>
                            </button>
                            <button className="admin-k-button" onClick={(event) => {
                                event.preventDefault();
                                this.props.changeView({ view: "AddItems" })
                            }}>
                                <i className="fas fa-times"></i>
                                <span>CANCEL</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}



function mapStateToProps(state) {
    return {
        common: state.common,
        purchaseAndRenewals: state.purchaseAndRenewals
    };
}

export default connect(mapStateToProps, {
    addToPurchase,
    updatePurchase,
    changeView
})(ProductOrder);